import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "FormSection" }

import { PropType } from "vue";
import { FormSection, FormValue } from "@/types";
import FormItem from "@/components/ds/form/FormItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    section: {
        type: Object as PropType<FormSection>,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.items, (item, index) => {
      return (_openBlock(), _createBlock(FormItem, {
        key: index,
        item: item,
        value: __props.value
      }, null, 8, ["item", "value"]))
    }), 128))
  ]))
}
}

})